var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.28759 2.25001L3.15634 7.68126C2.96259 7.88751 2.77509 8.29376 2.73759 8.57501L2.50634 10.6C2.42509 11.3313 2.95009 11.8313 3.67509 11.7063L5.68759 11.3625C5.96884 11.3125 6.36259 11.1063 6.55634 10.8938L11.6876 5.46251C12.5751 4.52501 12.9751 3.45626 11.5938 2.15001C10.2188 0.856264 9.17509 1.31251 8.28759 2.25001Z",
    stroke: "url(#paint0_linear_4937_20893)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43164 3.15625C7.70039 4.88125 9.10039 6.2 10.8379 6.375",
    stroke: "url(#paint1_linear_4937_20893)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.875 13.75H13.125",
    stroke: "url(#paint2_linear_4937_20893)",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4937_20893",
    x1: 7.12179,
    y1: -0.378554,
    x2: 14.1008,
    y2: 9.78371,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4937_20893",
    x1: 9.00703,
    y1: 2.61979,
    x2: 11.0928,
    y2: 5.95524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4937_20893",
    x1: 7.07812,
    y1: 13.5833,
    x2: 7.16263,
    y2: 15.0198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF765C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5349"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.c64eac74be776ba4bc3df1f77a8b2ed8.svg";
export { ForwardRef as ReactComponent };